import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import type React from "react";
import {FormGroup} from "reactstrap";

type Props = {
  disabled: boolean;
  onColorChange: React.Dispatch<React.SetStateAction<string | null>>;
  currentColor: string;
  onToolChange: React.Dispatch<React.SetStateAction<"square" | "free" | null>>;
  currentTool: "square" | "free" | null;
};

const COLORS = ["#785bc7", "#3976f9", "#d16585"];

export function ToolBox({
  disabled,
  onColorChange,
  currentColor,
  onToolChange,
  currentTool,
}: Props) {
  return (
    <FormGroup>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginLeft: "10px",
          marginRight: "10px",
        }}
      >
        <div style={{display: "flex", gap: "10px"}}>
          {COLORS.map((color) => (
            <div
              key={color}
              onClick={() => !disabled && onColorChange(color)}
              style={{
                width: "30px",
                height: "30px",
                backgroundColor: color,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
                borderRadius: "4px",
                boxShadow: color === currentColor ? "0 2px 12px rgba(0, 0, 0, 0.5)" : "none",
              }}
            />
          ))}
        </div>
        <div style={{display: "flex", gap: "10px"}}>
          <div
            onClick={() => !disabled && onToolChange(null)}
            style={{
              padding: "6px 9px",
              backgroundColor: currentTool === null ? "#f0f0f0" : "white",
              border: "1px solid #ddd",
              borderRadius: "4px",
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              fontWeight: currentTool === null ? "bold" : "normal",
            }}
          >
            <FontAwesomeIcon icon="hand" />
          </div>
          <div
            onClick={() => !disabled && onToolChange("free")}
            style={{
              padding: "6px 9px",
              backgroundColor: currentTool === "free" ? "#f0f0f0" : "white",
              border: "1px solid #ddd",
              borderRadius: "4px",
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              fontWeight: currentTool === "free" ? "bold" : "normal",
              color: currentColor,
            }}
          >
            <FontAwesomeIcon icon="pen" />
          </div>
          <div
            onClick={() => !disabled && onToolChange("square")}
            style={{
              padding: "6px 9px",
              backgroundColor: currentTool === "square" ? "#f0f0f0" : "white",
              border: "1px solid #ddd",
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              fontWeight: currentTool === "square" ? "bold" : "normal",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                border: `2px solid ${currentColor}`,
              }}
            />
          </div>
        </div>
      </div>
    </FormGroup>
  );
}
